import * as React from 'react';

import Container from 'components/Container';
import Heading from 'components/Heading';
import Link from 'components/Link';
import MockAnnouncementChubble from 'chat/components/MockAnnouncementChubble';
import OrgAvatar from 'organizations/components/OrgAvatar';
import Row from 'components/Row';
import Text from 'components/Text';
// @ts-ignore
import TranslatableText from 'chat/components/TranslatableText';
import UrgentAvatar from 'chat/components/UrgentAvatar';

export type Props = {
  messageBody?: string;
  fileAttachmentUuids?: string[];
  senderNameOrSignature: string;
  selectedOrgName?: string;
  isUrgent: boolean;
};

function BorderedPreviewBox(props: { children: React.ReactNode }) {
  return (
    <Container size="small" align="left">
      <div className="AdminNewAutoMessageReview-box">
        <Text align="center" element="div">
          <Text color="wolf" size="xsmall">
            This is a preview
          </Text>
          <div className="AdminNewAutoMessageReview-box-preview">
            {props.children || (
              <Text italic color="eclipse">
                Compose your message and select a sender in order to see a preview
              </Text>
            )}
          </div>
        </Text>
      </div>
    </Container>
  );
}

export default function AdminNewAutoMessageReviewMessagePreviews(props: Props) {
  const {
    messageBody,
    senderNameOrSignature,
    selectedOrgName,
    isUrgent,
    fileAttachmentUuids,
  } = props;
  const truncatedMessageBody = messageBody && messageBody.slice(0, 899);

  const fullMessageText = `${senderNameOrSignature}: ${truncatedMessageBody}`;

  return (
    <React.Fragment>
      <Heading level="3" levelStyle="4">
        1. Preview message
      </Heading>
      <Row>
        <BorderedPreviewBox>
          {truncatedMessageBody ? (
            <div className="AdminNewAutoMessageReview-chatBubble">
              <TranslatableText key={fullMessageText} initialText={fullMessageText} />
              {fileAttachmentUuids &&
                fileAttachmentUuids.length > 0 && (
                  <Link data-test="sms-file-attachment" noHover>
                    rmd.me/linkToYourFile
                  </Link>
                )}
            </div>
          ) : null}
        </BorderedPreviewBox>
      </Row>
      <Row>
        <BorderedPreviewBox>
          {truncatedMessageBody ? (
            <MockAnnouncementChubble
              senderName={selectedOrgName || 'Organization name'}
              senderSubtext="Shared with you"
              senderAvatar={isUrgent ? <UrgentAvatar size="small" /> : <OrgAvatar size="small" />}
              messageBody={truncatedMessageBody}
              key={fullMessageText}
              isUrgent={isUrgent}
              fileAttachmentUuids={fileAttachmentUuids}
            />
          ) : null}
        </BorderedPreviewBox>
      </Row>
    </React.Fragment>
  );
}
